import { graphql } from 'gatsby'
import './opportunity'

export const fragment = graphql`
fragment prismicEventFragmentPartial on PrismicEvent {
  url
  uid
  type
  prismicId
  lang
  tags
  alternate_languages {
    document {
      ... on PrismicPage {
        url
        lang
      }
    }
  }
  data {
    title {
      text
    }
    override_image {
      url
    }
    override_description
    text_on_card {
      html
    }
    image {
      url
      alt
      thumbnails {
        thumbnail {
          url
          alt
        }
      }
    }
    dagsetning
    cost
    body {
      ... on PrismicEventBodyRichtext {
        ...sliceFragmentPrismicEventBodyRichtext
      }
      ... on PrismicEventBodyHeroMedia {
        ...sliceFragmentPrismicEventBodyHeroMedia
      }
      ... on PrismicEventBodySeo {
          ...sliceFragmentPrismicEventBodySeo
      }
    }
  }
}
fragment prismicEventFragmentFull on PrismicEvent {
  ...prismicEventFragmentPartial
  data {
    opportunities {
      opportunity {
        document {
          ...prismicOpportunityFragmentFull
        }
      }
    }
  }
}
fragment sliceFragmentPrismicEventBodyRichtext on PrismicEventBodyRichtext {
  primary {
    content {
      html
    }
  }
}

fragment sliceFragmentPrismicEventBodySeo on PrismicEventBodySeo {
  id
  slice_type
  primary {
    override_title
    override_description
    override_keywords
    override_image {
      url
    }
  }
}

fragment sliceFragmentPrismicEventBodyHeroMedia on PrismicEventBodyHeroMedia {
  id
  slice_type
  primary {
    caption
    single_image {
      url
      alt
    }
    video {
      url
    }
    firstonpage
  }
  items {
    gallery_image {
      url
    }
    image_title
    image_caption
  }
}
`
